import { Feature } from "lib/@components/feature"
import { If } from "lib/@components/switch"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/server/feature-flag-tailored-schedule-auditing.mjs"
import { Else } from "lib/@components/else"
import { TailoringRejections } from "./tailoring-rejections"

export function TailoringRejectionChecker({ children, step, message }) {
    return (
        <Feature feature={FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING} fallback={children}>
            <If field="activeStep.props.id" equals={step}>
                <TailoringRejections step={step} message={message}>
                    {children}
                </TailoringRejections>
                <Else>{children}</Else>
            </If>
        </Feature>
    )
}
